/** Default max line-up music upload size (100 MiB). */
export const DEFAULT_CASTING_LINEUP_MUSIC_MAX_BYTES = 100 * 1024 * 1024;

/** Hard platform cap for configured line-up music uploads (200 MiB). */
export const ABSOLUTE_CASTING_LINEUP_MUSIC_MAX_BYTES = 200 * 1024 * 1024;

const MIN_CASTING_LINEUP_MUSIC_MAX_BYTES = 1024 * 1024;

export function resolveCastingLineupMusicMaxBytes(raw?: number | null): number {
  if (typeof raw === 'number' && Number.isFinite(raw) && raw >= MIN_CASTING_LINEUP_MUSIC_MAX_BYTES) {
    return Math.min(Math.floor(raw), ABSOLUTE_CASTING_LINEUP_MUSIC_MAX_BYTES);
  }
  return DEFAULT_CASTING_LINEUP_MUSIC_MAX_BYTES;
}

export function formatCastingLineupMusicMaxMb(maxBytes: number): string {
  return `${Math.round(maxBytes / (1024 * 1024))} MB`;
}
